<template>
	<div id="body-container">
		<navbar />
		<div class="flex">
			<div :class="{ 'w-40': isToggling, 'w-10': !isToggling }">
				<sidemenubar />
			</div>
			<div class="content flex-1 w-full" :class="{ toggledstate: isToggling }">
				<div class="page">
					<slot />
				</div>
				<Footer />
			</div>
		</div>
	</div>
</template>
<style  scoped>
.page{
	margin-bottom: 150px;
}
</style>
 <script lang="ts">
import navbar from '@/components/navbar.vue';
import sidemenubar from '@/components/sidemenubar.vue';
import Footer from '@/components/footer.vue'
import { defineComponent } from 'vue';
import { emitter } from '../main';
export default defineComponent({
	components: {
		navbar,
		sidemenubar,
		Footer
	},
	data() {
		return {
			isToggling: true
		};
	},
	mounted() {
		emitter.on('toggle-sidebar', (isToggle: any) => {
			this.isToggling = isToggle;
		});
	}
});
</script>